import { render, staticRenderFns } from "./FormularioPlanesPrecios.vue?vue&type=template&id=28035bf2"
import script from "./FormularioPlanesPrecios.vue?vue&type=script&lang=js"
export * from "./FormularioPlanesPrecios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports